import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from 'libs/portal/src/layout/layout.service';
import { GraphChange } from 'libs/portal/src/models/GraphChange';
import { TIMEFRAMES } from 'libs/portal/src/models/types/Timeframes';
import { TIMEPERIODS } from 'libs/portal/src/models/types/TimePeriods';
import { SegmentedTileModel } from 'libs/portal/src/modules/keepalive/models/SegmentedTile';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { MemoryService } from 'libs/portal/src/services/memory/memory.service';
import { ToastrService } from 'ngx-toastr';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { TimeAgoService } from '@huge-monorepo/hip/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cdr-dashboard',
  templateUrl: './cdr-dashboard.page.html',
  styleUrls: ['./cdr-dashboard.page.scss'],
})
export class CdrDashboardPageComponent implements OnInit, OnDestroy {
  constructor(
    public layoutService: LayoutService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private auth: UserRightsService,
    private toast: ToastrService,
    private memoryService: MemoryService,
    private timeAgoService: TimeAgoService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  @ViewChild('vC', { static: false }) vC: GraphChange;
  @ViewChild('mC', { static: false }) mC: GraphChange;
  @ViewChild('tC', { static: false }) tC: GraphChange;

  groupId: number;
  deviceStatusCount: any[] = [];
  newDevicesCount: any[] = [];
  groupBundleCount: any[] = [];
  activeDeviceHistory: any[] = [];
  onlineDeviceCount: number;
  offlineDeviceCount: number;
  deviceStatusCountTotal: string;
  TotalCDRDevices = 0;
  memorySub: Subscription;
  Limit = 20;
  Offset = 0;
  CurrentPage = 1;
  lastUpdate: string = this.timeAgoService.transform(new Date().toISOString());

  dataTiles2: any[];
  dataTiles5: any[];
  dataTiles4: any[];

  cdrHealth: any;
  cdrHealthStatuses: any[] = [];
  showAllDevices: boolean = true;

  deviceUsageData: any[];
  // usageOverMonthData: any = null;
  // monthGraphObject: any;
  daysInMonth: number;
  usageOverMonthsData: any = null;
  usageOverMonthsStorage: any[] = [];
  monthsDataDates: string;
  deviceBundleUsage: any[] = [];
  dataBundleUsageQuadrants: any[] = [];
  lastUpdatedStatus: string;
  isUsageDataLoaded = false;

  DailyDataUsageGraphConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Bundle used in GB',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  MonthlyDataUsageGraphConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Data usage over 6 months',
      GraphType: 'bar',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  Top20DevicesGraphConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Bundle used in MB',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: '',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  dashboardData: any;

  monthlyToggle = false;
  dailyToggle = false;
  daterangeStart: any = null;
  daterangeEnd: any = null;
  currTimeFrame = 3;
  disableCaching = false;
  unit: string;
  pastMonthsTitle: string;

  currentMonth: Date = new Date();

  getAllDevices = true;
  willExceedBundle = false;
  enableRefresher = false;
  customLegendItems = ['Over Bundle', 'Under Bundle', 'Expected to Exceed Bundle'];
  customLegendColors = ['#C93F55', '#3FC944', '#FFBE65'];
  apnGraphColors = ['#FFA600', '#FF853D', '#FF6765', '#166ABE', '#7567C6', '#B25FBE', '#E256A9', '#FF5689'];

  // Vodacom APN Usage
  VodacomConfig: GraphChange = {
    Callback: null,
    Transformer: this.apnDataFormatter,
    StartDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    EndDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    Timeperiod: TIMEPERIODS.find((elem) => elem.iD == 2),
    TimeFrame: TIMEFRAMES.find((elem) => elem.iD == 3),
    Interval: 1,
    Data: {
      GraphTitle: 'Vodacom Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'Date',
      YAxisLabel: 'Data (in GB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };

  // MTN APN Usage
  MTNConfig: GraphChange = {
    Callback: null,
    Transformer: this.apnDataFormatter,
    StartDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    EndDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    Timeperiod: TIMEPERIODS.find((elem) => elem.iD == 2),
    TimeFrame: TIMEFRAMES.find((elem) => elem.iD == 3),
    Interval: 1,
    Data: {
      GraphTitle: 'MTN Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'Date',
      YAxisLabel: 'Data (in GB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };

  // Telkom APN Usage
  TelkomConfig: GraphChange = {
    Callback: null,
    Transformer: this.apnDataFormatter,
    StartDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    EndDate: this.tools.GetStartOfMonth(this.currentMonth).toISOString(),
    Timeperiod: TIMEPERIODS.find((elem) => elem.iD == 2),
    TimeFrame: TIMEFRAMES.find((elem) => elem.iD == 3),
    Interval: 1,
    Data: {
      GraphTitle: 'Telkom Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'Date',
      YAxisLabel: 'Data (in GB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };

  apnsLoading = true;
  isAggregated = true;

  ngOnInit(): void {
    this.disableCaching = this.auth.HasSessionChanged();
    if (this.disableCaching) {
      this.auth.SetSessionChanged(false);
    }

    this.isAggregated = this.auth.IsAggregated();
    if (!this.isAggregated) {
      this.customLegendItems = ['Usage'];
      this.customLegendColors = ['#3FC944'];
    }

    this.unit = this.memoryService.getLocalPreferences().getValue().preferedGraphUnit;
    this.pastMonthsTitle = `Usage past 6 months (in ${this.unit})`;
    this.memorySub = this.memoryService.getLocalPreferences().subscribe((prefs) => {
      if (this.unit != prefs.preferedGraphUnit) {
        //Update objects with correct conversions
        this.unit = prefs.preferedGraphUnit;
        this.pastMonthsTitle = `Usage past 6 months (in ${this.unit})`;
        this.getAPNData(this.VodacomConfig, this.MTNConfig, this.TelkomConfig);
      }
    });
    this.groupId = this.auth.GetGroupID();
    this.getDashboardData();
  }

  ngOnDestroy(): void {
    this.memorySub.unsubscribe();
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  apnDataFormatter(c: GraphChange) {
    let labels = [];

    const seriesData = [];
    let grouped = c.GraphDashboard.groupBy(c.UnprocessedData, (item) => item.APN);
    let firstGroup: {
      APN: string;
      Date: Date;
      NumDevices: number;
      ServiceProvider: string;
      Usage: number;
    }[] = [];

    // Order dates
    grouped.forEach((value: any) => {
      value.sort((a, b) => a.Date.localeCompare(b.Date));
    });

    // Order APNs by most used
    // TODO: Put this back in and fix when they complain about colors changing
    // grouped = new Map([...grouped.entries()].sort((a, b) => {
    // 	let initialA = 0;
    // 	let initialB = 0;
    // 	b[1].reduce((previousValue, currentValue) => previousValue.Usage + currentValue.Usage, initialB);
    // 	a[1].reduce((previousValue, currentValue) => previousValue.Usage + currentValue.Usage, initialA);
    // 	return initialB - initialA;
    // }));

    grouped.forEach(
      (
        value: {
          APN: string;
          Date: Date;
          NumDevices: number;
          ServiceProvider: string;
          Usage: number;
        }[],
        key: string,
      ) => {
        firstGroup = value;
        seriesData.push({
          name: key,
          data: value.map((item) => item.Usage.toFixed(1)),
        });
      },
    );

    firstGroup.map((item) => {
      labels.push(c.GraphDashboard.tools.FormatSwedishDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(item.Date)));
    });

    c.Data.SeriesData = seriesData;

    c.Data.XAxisCategories = labels;
  }

  getDashboardData(): void {
    this.getDashboardView(new Date());
  }

  getDashboardView(month: Date): void {
    let dateObj = {
      Start: this.tools.GetStartOfMonth(month),
      End: this.tools.GetEndOfMonthFromDate(month),
    };
    this.genericService
      .POST(this.endpoints.GET_CDR_DASHBOARD, {
        Month: this.tools.FormatStartDate(this.tools.GetStartOfMonth(month).toISOString()),
      })
      .subscribe((res: any) => {
        this.dashboardData = res['body'];

        this.getDevicesHealth();
        this.getDeviceUsageOvertime(dateObj);
        this.getDeviceUsageOvertimeMonths(month);
        this.getDeviceUsageList();
        this.getAPNData(this.VodacomConfig, this.MTNConfig, this.TelkomConfig);
        let date = this.tools.ParseAPIDate(this.dashboardData.LastUpdated);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        this.lastUpdate = this.timeAgoService.transform(date.toISOString());
        this.changeDetectorRef.detectChanges();
      });
  }

  getAPNData(
    VodacomConfig,
    MTNConfig,
    TelkomConfig,
    dateObj?: {
      Start: string;
      End: string;
    },
  ) {
    if (VodacomConfig != null) VodacomConfig.IsReady = false;
    if (MTNConfig != null) MTNConfig.IsReady = false;
    if (TelkomConfig != null) TelkomConfig.IsReady = false;

    this.apnsLoading = false;
    const vodacom = [];
    const mtn = [];
    const telkom = [];
    let data: {
      APN: string;
      Date: Date;
      NumDevices: number;
      ServiceProvider: string;
      Usage: number;
    }[] = this.dashboardData.APNDailyUsage;
    if (data != null) {
      data.map((item) => {
        item.Usage = this.tools.ConvertDataFromBytes(item.Usage, this.unit);
        if (item.ServiceProvider == 'MTN') {
          mtn.push(item);
        } else if (item.ServiceProvider == 'Vodacom SA') {
          vodacom.push(item);
        } else if (item.ServiceProvider == 'Telkom') {
          telkom.push(item);
        }
      });
    }
    if (mtn.length != 0) {
      MTNConfig.UnprocessedData = mtn;
      MTNConfig.Data.YAxisLabel = `Data (in ${this.unit})`;
      MTNConfig.IsReady = true;
      if (MTNConfig.Callback != null) {
        MTNConfig.Callback(MTNConfig);
      }
    }
    if (vodacom.length != 0) {
      VodacomConfig.UnprocessedData = vodacom;
      VodacomConfig.Data.YAxisLabel = `Data (in ${this.unit})`;
      VodacomConfig.IsReady = true;
      if (VodacomConfig.Callback != null) {
        VodacomConfig.Callback(VodacomConfig);
      }
    }
    if (telkom.length != 0) {
      TelkomConfig.UnprocessedData = telkom;
      TelkomConfig.Data.YAxisLabel = `Data (in ${this.unit})`;
      TelkomConfig.IsReady = true;
      if (TelkomConfig.Callback != null) {
        TelkomConfig.Callback(TelkomConfig);
      }
    }
  }

  getDeviceUsageOvertime(dateObj?: any): void {
    let data = this.dashboardData.DailyBundleUsage;
    let c = this.DailyDataUsageGraphConfig;
    if (data != null) {
      let graphObject = {
        month: dateObj ? this.tools.GetDateMonthName(this.tools.ParseAPIDate(dateObj.Start.toISOString())) : this.tools.GetCurrentMonthName(),
        year: dateObj ? this.tools.GetDateYear(this.tools.ParseAPIDate(dateObj.Start.toISOString())) : this.tools.GetCurrentYear(),
        dataUsed: [],
        weeks: [],
        projected: [],
        totalData: [],
        isCumulative: true,
      };
      let tempStart = dateObj && dateObj.Start ? dateObj.Start : new Date();
      let tempEnd = dateObj && dateObj.End ? dateObj.End : new Date();
      let title = 'Bundle used in MB (' + this.tools.GetStartOfMonth(tempStart).toLocaleDateString('sv-SE') + ' - ' + tempEnd.toLocaleDateString('sv-SE') + ')';

      console.log(data);
      if (data['UsageOverTime'] != null) {
        for (let i = 0; i < data['UsageOverTime'].length; i++) {
          graphObject['dataUsed'].push(this.tools.ConvertDataFromBytes(data['UsageOverTime'][i]['TotalUsage'], 'MB'));
          graphObject['weeks'].push(this.tools.FormatSwedishDate(this.tools.ParseAPIDate(data['UsageOverTime'][i]['Start'])));
          if (this.isAggregated) {
            graphObject['totalData'].push(this.tools.ConvertDataFromBytes(data['BundleOverTime'][i]['InBundleAmount'], 'MB'));
          }
        }
      }

      graphObject['dataUsed'] = this.tools.CalculateUsages(graphObject['dataUsed']);

      if (dateObj) {
        graphObject['NewDate'] = this.tools.ParseAPIDate(dateObj.Start.toISOString());
      }

      if (graphObject['dataUsed'].length >= 2) {
        let projectionData = this.tools.calculateProjectionData(graphObject);
        this.daysInMonth = projectionData.daysInMonth;
        graphObject = projectionData.graphObject;
      } else {
        this.daysInMonth = graphObject['dataUsed'].length;
      }

      if (this.isAggregated) {
        let bundleAmount = graphObject['totalData'][graphObject['totalData'].length - 1];
        for (let i = graphObject['totalData'].length; i < this.daysInMonth; i++) {
          graphObject['totalData'].push(bundleAmount); // Fill rest of month with last InBundleAmount
        }
      }

      if (dateObj) {
        let usageTileData = {};
        let flag = true;
        for (let i = graphObject['totalData'].length - 1; i > -1; i--) {
          if (graphObject['dataUsed'][i] != null && graphObject['dataUsed'][i] <= graphObject['totalData'][i]) {
            if (
              graphObject['dataUsed'][i + 1] >= graphObject['totalData'][i + 1] &&
              graphObject['dataUsed'][graphObject['dataUsed'].length - 1] >= graphObject['totalData'][graphObject['totalData'].length - 1]
            ) {
              usageTileData['ExceedDate'] = graphObject['weeks'][i + 1];
              usageTileData['DoesExceed'] = true;
              flag = false;
              break;
            }
          }
        }

        if (flag) {
          for (let i = graphObject['projected'].length - 1; i > -1; i--) {
            if (
              graphObject['projected'][i] <= graphObject['totalData'][i] &&
              graphObject['projected'][i + 1] >= graphObject['totalData'][i + 1] &&
              graphObject['projected'][graphObject['projected'].length - 1] >= graphObject['totalData'][graphObject['totalData'].length - 1]
            ) {
              usageTileData['ExceedDate'] = graphObject['weeks'][i + 1];
              usageTileData['DoesExceed'] = true;
              break;
            }
          }
        }

        usageTileData['ExceedValue'] = graphObject['projected'][graphObject['projected'].length - 1] - graphObject['totalData'][graphObject['totalData'].length - 1];
        usageTileData['FinalUsage'] = graphObject['projected'][graphObject['projected'].length - 1];
        usageTileData['ProjectedValue'] = graphObject['projected'];
        this.setUsageTileData(usageTileData);

        if (graphObject.projected.length >= 2 && graphObject.projected[graphObject.projected.length - 1] > graphObject.totalData[graphObject['totalData'].length - 1]) {
          this.willExceedBundle = true;

          if (this.usageOverMonthsData != null) {
            let temp = this.usageOverMonthsData;
            this.usageOverMonthsData = null;
            temp[temp.length - 1]['WillExceedBundle'] = true;
            setTimeout(() => {
              this.usageOverMonthsData = temp;
            });
          }
        }
      }

      let tempSeries = [
        {
          name: 'Projection (MB)',
          data: graphObject.projected,
          color: '#FFB347',
        },
        {
          name: 'Bundle (MB)',
          data: graphObject.totalData,
          color: '#990000',
        },
        {
          name: 'Data Used (MB)',
          data: graphObject.dataUsed,
          color: '#3FC944',
        },
      ];

      c.UnprocessedData = data;
      c.Data.GraphTitle = title;
      c.Data.SeriesData = tempSeries;
      c.Data.XAxisCategories = graphObject['weeks'] ? graphObject['weeks'] : [];
      c.IsReady = true;
      if (c.Callback != null) {
        c.Callback(c);
      }
    }
  }

  getDeviceUsageOvertimeMonths(monthDiff): void {
    let data = this.dashboardData.MonthlyBundleUsage;
    let c = this.MonthlyDataUsageGraphConfig;
    let graphObject = {
      month: 'January',
      year: '2022',
      dataUsed: [],
      weeks: [],
      projected: [],
      totalData: [],
    };
    if (data != null) {
      let data = this.dashboardData.MonthlyBundleUsage.UsageOverTime;
      let bundle = this.dashboardData.MonthlyBundleUsage.BundleOverTime;
      this.usageOverMonthsStorage = this.dashboardData.MonthlyBundleUsage.UsageOverTime;
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        // Formatting for the six months data
        let tempDate = this.tools.ParseAPIDate(data[i]['Start']);
        temp.push({
          TotalUsage: this.tools.ConvertDataFromBytes(data[i]['TotalUsage'], 'MB').toFixed(1),
          Start: `${tempDate.getFullYear()}-${('0' + (tempDate.getMonth() + 1)).slice(-2)}`, // Formatting date to show only month and year, also 0 if month < 10
          ExceededUsage: data[i]['TotalUsage'] > bundle[i]['InBundleAmount'],
        });

        if (i == data.length - 1) {
          temp[temp.length - 1]['WillExceedBundle'] = this.willExceedBundle;
        }

        graphObject['dataUsed'].push(temp[i]['TotalUsage']);
        graphObject['weeks'].push(temp[i]['Start']);
      }

      if (!this.isAggregated) {
        temp.forEach((element) => {
          element.ExceededUsage = false;
        });
      }

      let seriesData = [];
      seriesData.push({
        name: 'Data Used (MB)',
        data:
          temp.map((entry, i) => {
            return {
              x: entry.Start,
              y: entry.TotalUsage,
              fillColor: entry.ExceededUsage ? '#990000' : '#3FC944',
            };
          })
      });

      if (c.Callback != null) {
        c.UnprocessedData = data;
        c.Callback(c);
      } else {
        c.UnprocessedData = data;
      }

      c.Data.SeriesData = seriesData;
      c.Data.XAxisCategories = graphObject['weeks'] ? graphObject['weeks'] : [];
      c.IsReady = true;

      this.usageOverMonthsData = temp;
    }
  }

  getDevicesHealth(): void {
    let thisMonth = new Date();
    let data = this.dashboardData.DashboardHealth;
    if (data != null) {
      this.deviceStatusCountTotal = `${this.tools.AccountingStringType(data.Total)} Devices`;
      this.cdrHealth = data;
      this.deviceBundleUsage = [
        {
          title: 'Devices over 80% of bundle',
          titleColor: 'primary',
          value: `${this.tools.AccountingStringType(data.HighUsage)}`,
          valueColor: 'primary',
          tileColor: 'light',
          subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} - ${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
            ? thisMonth.toLocaleDateString('sv-SE')
            : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
            }`,
          subTitleColor: 'primary',
        },
        {
          title: 'Devices below 80% of bundle',
          titleColor: 'primary',
          value: `${this.tools.AccountingStringType(data.OKUsage)}`,
          valueColor: 'primary',
          tileColor: 'light',
          subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} - ${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
            ? thisMonth.toLocaleDateString('sv-SE')
            : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
            }`,
          subTitleColor: 'primary',
        },
        {
          title: 'Devices with no usage',
          titleColor: 'primary',
          value: `${this.tools.AccountingStringType(data.NoUsage ?? 0)}`,
          valueColor: 'primary',
          tileColor: 'light',
          subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} - ${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
            ? thisMonth.toLocaleDateString('sv-SE')
            : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
            }`,
          subTitleColor: 'primary',
        },
      ];

      this.dataBundleUsageQuadrants = [
        {
          value: data.Q0 ?? 0,
          label: 'no usage',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.Q1,
          label: '< 25% usage',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.Q2,
          label: '< 50% usage',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.Q3,
          label: '< 75% usage',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.Q4,
          label: '< 100% usage',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.Q5,
          label: 'out of bundle',
          valueColor: 'primary',
          labelColor: 'primary',
        },
      ];

      this.activeDeviceHistory = [
        {
          value: data.NowOnline,
          label: 'Today',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.UsageDay,
          label: '> 1 day ago',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: data.UsageWeek,
          label: '> 1 week ago',
          valueColor: 'primary',
          labelColor: 'primary',
        },
      ],
        this.newDevicesCount = [];
      this.newDevicesCount.push({
        title: 'Average Usage Per Device',
        titleColor: 'primary',
        value: this.tools.FormatUsage(data.TotalUsage / (data.Total || 1)),
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} -
							${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
            ? thisMonth.toLocaleDateString('sv-SE')
            : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
          }`,
        subTitleColor: 'primary',
      });

      data.InBundleAmount ??= 0;

      let isZero = data.InBundleAmount == 0 && data.TotalUsage == 0;

      let aggregateUsage = this.tools.FormatUsage(data.TotalUsage);
      let aggregateSplit = aggregateUsage.split(' ');
      let bundlesArr = this.dashboardData.DailyBundleUsage.BundleOverTime as any[];
      let bundleVal = 0;
      if (bundlesArr?.length == 0) {
        bundleVal = data.InBundleAmount;
      } else {
        bundleVal = bundlesArr[bundlesArr.length - 1]['InBundleAmount'];
      }
      let aggregateBundle = this.tools.FormatUsage(bundleVal);
      let title = `Usage (in ${aggregateSplit[1]})`;
      if (this.isAggregated) {
        title = 'Bundle ' + title;
      }

      let value = `${aggregateUsage.slice(0, -3)} / ${aggregateBundle.slice(0, -3)}`;
      if (isZero) {
        value = 'N/A';
      }

      this.groupBundleCount = [];

      if (aggregateUsage.slice(-2) == aggregateBundle.slice(-2)) {
        this.groupBundleCount.push({
          title: title,
          titleColor: 'primary',
          value: this.isAggregated ? value : aggregateSplit[0],
          valueColor: 'primary',
          tileColor: 'light',
          subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} -
								${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
              ? thisMonth.toLocaleDateString('sv-SE')
              : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
            }`,
          subTitleColor: 'primary',
        });
      } else {
        this.groupBundleCount.push({
          title: this.isAggregated ? `Bundle Usage` : 'Usage',
          titleColor: 'primary',
          value: this.isAggregated ? `${aggregateUsage} / ${aggregateBundle}` : `${aggregateUsage}`,
          valueColor: 'primary',
          tileColor: 'light',
          subTitle: `${this.tools.GetStartOfMonth(this.currentMonth).toLocaleDateString('sv-SE')} -
									${this.tools.GetStartOfMonth(thisMonth).toDateString() == this.tools.GetStartOfMonth(this.currentMonth).toDateString()
              ? thisMonth.toLocaleDateString('sv-SE')
              : this.tools.GetEndOfMonthFromDate(this.currentMonth).toLocaleDateString('sv-SE')
            }`,
          subTitleColor: 'primary',
        });
      }
    }
  }

  deviceUsagePaginated(eve): void {
    this.Offset = (eve - 1) * this.Limit;
    this.deviceUsageData = [];
    this.getDeviceUsageList();
  }

  selectionChanged(allDevices: boolean): void {
    this.showAllDevices = allDevices;
    this.getDeviceUsageList();
  }

  barSelected(index: number): void {
    if (this.deviceUsageData != null && this.deviceUsageData[index] != null) {
      this.tools.CopyToClipboard(this.deviceUsageData[index].DeviceNum);
      this.toast.info('', this.deviceUsageData[index].DeviceNum + ' copied to clipboard', { timeOut: 2000, positionClass: 'toast-bottom' });
    }
  }

  getDeviceUsageList(): void {
    this.isUsageDataLoaded = false;

    let data: any[] = this.dashboardData.TopDevices;
    if (this.showAllDevices === false) {
      data = this.dashboardData.TopActiveDevices;
    }

    if (data != null) {
      this.deviceUsageData = [...data];
      this.deviceUsageData.forEach((elem) => {
        elem.ExceededUsage = null;
        return elem;
      });
    }

    this.deviceUsageData = this.deviceUsageData?.filter((val) => {
      return val.TotalUsage != 0;
    });

    this.TotalCDRDevices = this.dashboardData.DashboardHealth?.Total;
    this.isUsageDataLoaded = true;
  }

  doRefresh(event): void {
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  }

  lastSixMonthsPointSelected(index: number) {
    let tempDate = this.tools.ParseAPIDate(this.usageOverMonthsStorage[index]['Start']);
    this.currentMonth = this.tools.GetStartOfMonth(tempDate);
    let thisMonth = this.tools.GetStartOfMonth(new Date());
    this.enableRefresher = !(thisMonth.toLocaleDateString() == this.currentMonth.toLocaleDateString());
    this.getDashboardView(this.currentMonth);
  }

  setUsageTileData(data) {
    let dt = new Date();
    if (data.ExceedDate != null) {
      let st = data.ExceedDate;
      let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
      dt = new Date(st.replace(pattern, '$3-$2-$1'));
    }
    this.cdrHealthStatuses = [];

    const expectedAverageVal = this.tools.FormatUsage(
      (data.ProjectedValue ? data.ProjectedValue[data.ProjectedValue.length - 1] * 1_000_000 : 0) / (this.dashboardData?.DashboardHealth?.Total || 1),
    );

    this.cdrHealthStatuses.push({
      title: 'Average Expected Usage Per Device',
      titleColor: data.ExceedDate ? 'light' : 'primary',
      value: expectedAverageVal,
      valueColor: data.ExceedDate ? 'light' : 'primary',
      tileColor: data.ExceedDate ? 'danger' : 'light',
      subTitle: `${this.currentMonth.getFullYear()}-${('0' + (this.currentMonth.getMonth() + 1)).slice(-2)}`,
      subTitleColor: data.ExceedDate ? 'light' : 'primary',
    });
    if (this.isAggregated) {
      this.cdrHealthStatuses.push({
        title: `Bundle Exceed Date`,
        titleColor: data.ExceedDate ? 'light' : 'primary',
        value: `${data.ExceedDate ? dt.toLocaleDateString('sv-SE') : 'N/A'}`,
        valueColor: data.ExceedDate ? 'light' : 'primary',
        tileColor: data.ExceedDate ? (dt.valueOf() > new Date().valueOf() ? 'warning' : 'danger') : 'light',
        subTitle: `${data.ExceedValue && data.ExceedValue > 0 ? ` (by ${this.tools.FormatUsage(data.ExceedValue)})` : '‎'}`,
        subTitleColor: data.ExceedDate ? 'light' : 'primary',
      });
    }
    this.cdrHealthStatuses.push({
      title: 'Expected Final Usage',
      titleColor: data.ExceedDate ? 'light' : 'primary',
      value: `${this.tools.FormatUsage(data.FinalUsage * 1_000_000)}`,
      valueColor: data.ExceedDate ? 'light' : 'primary',
      tileColor: data.ExceedDate ? 'danger' : 'light',
      subTitle: `${this.currentMonth.getFullYear()}-${('0' + (this.currentMonth.getMonth() + 1)).slice(-2)}`,
      subTitleColor: data.ExceedDate ? 'light' : 'primary',
    });
    this.cdrHealthStatuses.push(
      {
        title: "Capped Devices",
        titleColor: "primary",
        value: `${this.cdrHealth?.CappedDevices}`,
        valueColor: "primary",
        tileColor: "light",
        subTitle: `${this.currentMonth.getFullYear()}-${("0" + (this.currentMonth.getMonth() + 1)).slice(-2)}`,
        subTitleColor: "primary",
      },
    );
  }
}
